/**
 * Service: entitlementsApi
 */
angular.module('acme.common.service.entitlementsApi', [
    'acme.common.factory.apiVersion',
    'acme.common.factory.QueryStringBuilder'
])
    .service('EntitlementsApiService', ['$http', '$q', 'ApiVersionFactory', 'QueryStringBuilderFactory', function ($http, $q, ApiVersionFactory, QueryStringBuilderFactory) {

        return {

            service: '',

            endpoint: '',

            init: function (endpoint) {
                this.endpoint = endpoint;
                this.service = endpoint + '/event/templates';
                return true;
            },

            detail: function (templateId) {
                var av = new ApiVersionFactory();
                return $http({
                    method: 'get',
                    url: av.init({url: (this.service + '/' + templateId + '/entitlements'), version: 'v2'})
                });

            },

            create: function (templateId, props) {
                var av = new ApiVersionFactory();
                return $http({
                    method: 'post',
                    url: av.init({url: (this.service + '/' + templateId + '/entitlements'), version: 'v2'}),
                    data: {
                        eventTemplateId: templateId,
                        entitlementConfig: props.entitlementConfig || [],
                        salesRuleConfig: props.salesRuleConfig || [],
                        ticketRuleConfig: props.ticketRuleConfig || []
                    }
                });

            },

            update: function (templateId, props) {
                var av = new ApiVersionFactory();
                return $http({
                    method: 'put',
                    url: av.init({url: (this.service + '/' + templateId + '/entitlements'), version: 'v2'}),
                    data: {
                        id: props.id,
                        eventTemplateId: templateId,
                        salesRuleSetId: props.salesRuleSetId,
                        name: props.name,
                        entitlementConfig: props.entitlementConfig,
                        salesRuleConfig: props.salesRuleConfig || [],
                        ticketRuleConfig: props.ticketRuleConfig || []
                    }
                });

            },

            validateSalesRules: function(props) {
              var av = new ApiVersionFactory();

              props = props || {};
              props.saleChannel = "insideSalesIndividual";

              return $http({
                method: 'post',
                headers: {
                  'x-b2c-tenant-id': props.tenantId
                },
                url: av.init({url: this.endpoint + '/entitlements/validate', version: 'v2'}),
                data: {
                  id:  props.shoppingCartId
                }
              });
            }

        };

    }]);